import { render, staticRenderFns } from "./howitworks.vue?vue&type=template&id=4bd90551&"
import script from "./howitworks.vue?vue&type=script&lang=js&"
export * from "./howitworks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports